import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import { AssetSaveDialogData, AssetSaveDialogResult } from '@portal-workspace/grow-shared-library';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';


@Component({
    templateUrl: './asset-save.dialog.html',
    styleUrls: ['./asset-save.dialog.scss'],
    standalone: true,
    imports: [FlexModule, MatButtonModule, MatDialogModule]
})
export class AssetSaveDialog {

  constructor(@Inject(MAT_DIALOG_DATA) public data: AssetSaveDialogData,
              private dialogRef: MatDialogRef<AssetSaveDialog, AssetSaveDialogResult>) {
  }

  onSubmit($event: MouseEvent) {
    const result: AssetSaveDialogResult = {}
    this.dialogRef.close(result);
  }

  onCancel($event: MouseEvent){
    this.dialogRef.close()
  }
}

